import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../AuthProvider';
import './Feedback.css';

const Feedback = () => {
  const { user } = useAuth();
  const { interviewId } = useParams();
  const [transcript, setTranscript] = useState([]);
  const [feedback, setFeedback] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFeedback = async () => {
      try {
        const token = await user.getIdToken();
        const response = await fetch(`http://localhost:4242/interview/${interviewId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          setTranscript(data.transcript);

          // Fetch feedback from GPT API
          const feedbackResponse = await fetch('https://api.openai.com/v1/chat/completions', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
            },
            body: JSON.stringify({
              model: 'gpt-4o',
              messages: [
                { role: 'system', content: 'You are an expert interviewer providing feedback on a product management interview. Give clear and accurate feedback and include quotes of the user\'s response in your feedback' },
                { role: 'user', content: `Here is the transcript of the interview: ${JSON.stringify(data.transcript)}` },
              ],
              max_tokens: 800,
            }),
          });

          if (!feedbackResponse.ok) {
            throw new Error(`HTTP error! status: ${feedbackResponse.status}`);
          }

          const feedbackData = await feedbackResponse.json();
          const feedbackText = feedbackData.choices[0].message.content.trim();
          setFeedback(feedbackText);

          // Save feedback to the database
          await fetch(`http://localhost:4242/add-feedback`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ interviewId, feedback: feedbackText }),
          });
          console.log('Feedback saved:', feedbackText); // Debugging log
        } else {
          console.error('Failed to fetch interview details');
        }
      } catch (error) {
        console.error('Error fetching feedback:', error);
      }
    };

    fetchFeedback();
  }, [user, interviewId]);

  const handleSaveInterview = () => {
    navigate('/interviews');
  };

  return (
    <div className="feedback-container">
      <h2>Interview Feedback</h2>
      <p><strong>Transcript:</strong></p>
      <div className="transcript">
        {transcript.map((entry, index) => (
          <div key={index} className={`transcript-entry ${entry.role}`}>
            <strong>{entry.role}:</strong> {entry.text}
          </div>
        ))}
      </div>
      <p><strong>Feedback:</strong></p>
      <div className="feedback-text">{feedback}</div>
      <button onClick={handleSaveInterview}>Save Interview</button>
    </div>
  );
};

export default Feedback;